/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
    {
        url: "/tela-inicial/",
        name: "Tela Inicial",
        slug: "homepage",
        icon: "HomeIcon"
    },
    {
        url: null,
        name: "Sobre Econ",
        icon: "InfoIcon",
        submenu: [
            {
                url: "/acessibilidade/",
                name: "Acessibilidade",
                slug: "Acessibilidade"
            },
            {
                url: "/certificados-premios/",
                name: "Certificados e Prêmios",
                slug: "CertificadosPremios"
            },
            {
                url: "/quem-somos/",
                name: "Quem Somos",
                slug: "QuemSomos"
            }
        ]
    },

    // {
    //   url: "/contatos/",
    //   name: "Contatos",
    //   slug: "ContatosRecebidos",
    //   icon: "PhoneIncomingIcon",
    // },
    {
        url: null,
        name: "Empreendimentos",
        icon: "StarIcon",
        submenu: [
            {
                url: "/empreendimentos/lista",
                name: "Lista de Empreendimentos",
                slug: "lista-empreendimentos"
            },
            {
                url: "/empreendimentos/novo",
                name: "Novo Empreendimento",
                slug: "novo-empreendimento"
            },
            {
                url: "/empreendimentos-batch",
                name: "Atualização Infos",
                slug: "empreendimentos-batch"
            }
        ]
    },
    {
        url: "/fab/",
        name: "Fab",
        slug: "Fab",
        icon: "SunriseIcon"
    },
    {
        url: "/footer/",
        name: "Rodapé",
        slug: "Footer",
        icon: "UnderlineIcon"
    },
    {
        url: "/dados-contato/",
        name: "Dados para Contato",
        slug: "DadosContato",
        icon: "TargetIcon"
    },
    {
        url: "/menu/",
        name: "Menu",
        slug: "Menu",
        icon: "SidebarIcon"
    },
    {
        url: null,
        name: "Banners",
        icon: "MessageCircleIcon",
        submenu: [
            {
                url: "/banners-home/",
                name: "Banners Home",
                slug: "banners-home"
            },
            {
                url: "/banners-oportunidades/",
                name: "Banners Oportunidades",
                slug: "banners-oportunidades"
            }
        ]
    },
    {
        url: "/regulamentos/",
        name: "Regulamentos",
        slug: "Regulamentos",
        icon: "ArchiveIcon"
    },
    {
        url: "/venda-seu-terreno/",
        name: "Venda seu Terreno",
        slug: "venda-seu-terreno",
        icon: "NavigationIcon"
    },
    {
        url: "/consent-log",
        name: "Log de Consentimentos",
        slug: "consent-log",
        icon: "ArchiveIcon"
    },
    {
        url: null,
        name: "Trabalhe Conosco",
        icon: "StarIcon",
        submenu: [
            {
                url: "/cadastro-vagas/",
                name: "Cadastro de Vagas",
                slug: "CadastroVagas"
            },
            {
                url: "/candidatos-vagas/",
                name: "Candidatos",
                slug: "CandidatosVagas"
            }
        ]
    }
];
